module.exports = __webpack_public_path__ + "media/images/game_icon/vi/VG1007-fa8d483f34efa29b36f3a34ee070544f.png";